module.exports = __webpack_public_path__ + "img/payroll-service-platform-zh.cbccb390.png";